import { useMemo} from 'react'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponseData, useQueryResponseLoading} from './core/QueryResponseProvider'
import {LabelsListHeader} from './components/header/LabelsListHeader'
import { KTCard } from '../../../../_metronic/helpers'
import { LoadingIndicator } from '../../../components/widgets'
import { LabelResultCard } from './components/result/LabelResultCard'

const LabelSearchResult = () => {

    const data = useQueryResponseData();
    const isLoading = useQueryResponseLoading();

    
    const result = useMemo(() => {
        if (! (data && data.length > 0)) return null;
        return data[0];
    }, [data]);

    return (
    <>
    <KTCard className="p-10">
        <LabelsListHeader />        
    </KTCard>          

    {(! isLoading) && 
    <LabelResultCard details={result} />
    }
    <LoadingIndicator display={(isLoading)} status_text="Searching" />
    </>
    )
}

const SearchLabelsWrapper = () => (
    <QueryRequestProvider>
        <QueryResponseProvider>            
            <LabelSearchResult />            
        </QueryResponseProvider>
    </QueryRequestProvider>
)

export {SearchLabelsWrapper}
